import i18next from 'i18next';
import moment from 'moment';
import * as yup from 'yup';

export const yupDateRequired = yup
  .string()
  .transform((value, _, context) => (context.isType(value) ? moment(value).format('YYYY-MM-DD') : undefined))
  .required(i18next.t('yup-validation-date-required'));
